import * as React from 'react';
import { SyncIndicator } from 'screens/SyncScreen/SyncIndicator';
import { AssessmentListScreen } from './AssessmentListScreen';

export const AssessmentsTab: React.FC = () => {
  return (
    <>
      <AssessmentListScreen />
      <SyncIndicator showSyncIcon={false} />
    </>
  );
};
